export default __webpack_public_path__ + "static/media/healthy-habit.f53363ab.svg";